import { render, staticRenderFns } from "./tinymce-editor.vue?vue&type=template&id=1521f25c&"
import script from "./tinymce-editor.vue?vue&type=script&lang=js&"
export * from "./tinymce-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports